module.exports = __webpack_public_path__ + "static/BackupSecurity-cd4730c6bcb4dcb1370a6f4b24de409a.png";